<template>
  <div>
    <bfheader></bfheader>
    <userGroupHeader></userGroupHeader>
    <div class="main-content mt-2">
      <router-view></router-view>
    </div>

    <bffooter></bffooter>
  </div>
</template>

<script>
import bfheader from '@/components/BfHeader'
import bffooter from '@/components/BfFooter'
import userGroupHeader from '@/pages/userGroups/UserGroupHeader'

export default {
  name: 'UserGroupView',
  components: {
    bfheader,
    bffooter,
    userGroupHeader,
  },
  data () {
    return {
    }
  }
}
</script>
